import { render, staticRenderFns } from "./ApplicantPrintTitle.vue?vue&type=template&id=77bc2923"
import script from "./ApplicantPrintTitle.vue?vue&type=script&lang=js"
export * from "./ApplicantPrintTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports